import { ParamterType } from './paramter-type.enum';

export class SupplementaryEquipment {
    equipmentTypeId: string;
    name: string;
    selected: boolean;
    selectedIdentifier: string;
    availableIdentifiers: Array<string>;

    constructor(se: SupplementaryEquipment) {
        this.equipmentTypeId = se.equipmentTypeId;
        this.name = se.name;
        this.selected = se.selected;
        this.selectedIdentifier = se.selectedIdentifier;
        this.availableIdentifiers = se.availableIdentifiers;
    }
}

